import { MessageCircle, Sparkles, Users, User } from "lucide-react";
import { cn } from "@/lib/utils";

export type ChitChatTab = "chats" | "status" | "communities" | "profile";

const TABS: { value: ChitChatTab; label: string; Icon: typeof MessageCircle }[] = [
  { value: "chats", label: "Chats", Icon: MessageCircle },
  { value: "status", label: "Status", Icon: Sparkles },
  { value: "communities", label: "Communities", Icon: Users },
  { value: "profile", label: "Profile", Icon: User },
];

export function ChitChatBottomNav({
  value,
  onChange,
  className,
}: {
  value: ChitChatTab;
  onChange: (v: ChitChatTab) => void;
  className?: string;
}) {
  return (
    <nav
      className={cn(
        "border-t border-cc-border bg-cc-surface grid grid-cols-4",
        className,
      )}
    >
      {TABS.map(({ value: v, label, Icon }) => {
        const active = v === value;
        return (
          <button
            key={v}
            onClick={() => onChange(v)}
            className="relative flex flex-col items-center justify-center gap-0.5 py-2 transition"
            aria-current={active ? "page" : undefined}
          >
            {active && (
              <span className="absolute top-0 left-4 right-4 h-[3px] rounded-full bg-cc-terracotta" />
            )}
            <span
              className={cn(
                "h-9 w-9 rounded-full flex items-center justify-center transition-colors",
                active ? "bg-cc-terracotta-pale" : "bg-transparent",
              )}
            >
              <Icon
                className={cn(
                  "h-5 w-5",
                  active ? "text-cc-terracotta" : "text-cc-ink-soft",
                )}
              />
            </span>
            <span
              className={cn(
                "text-[10px] font-semibold",
                active ? "text-cc-terracotta" : "text-cc-ink-soft",
              )}
            >
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
